//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import { Message } from "element-ui";
import {
  moduleSelect,
  list,
  add,
  moduleDelete,
  update,
  orgList
} from "../comon/api/home";
export default {
  name: "List",
  created() {
    this._select();
    list({
      username: JSON.parse(localStorage.getItem("userInfos")).username,
      orgId: JSON.parse(localStorage.getItem("userInfos")).orgId
    }).then(res => {
      if (res.code == 200) {
        let data = localStorage.getItem("userInfo");
        let seesionId = localStorage.getItem("sessionId");
        let arr = data.split(",");
        res.data.forEach(element => {
          this.cities.push({
            menuName: element.menuName,
            menuId: element.menuId
          });
          for (let i = 0; i < arr.length; i++) {
            const id = arr[i];
            if (element.menuId == id) {
              this.citiesForloger.push({
                menuName: element.menuName,
                menuId: element.menuId
              });
            }
          }
        });
        this.cities = JSON.parse(JSON.stringify(this.cities));
      }
    }).catch(err => {
      console.log(err);
    });
    this._orgList()
  },
  mounted() { },
  computed: {
    changeTo(obj) {
      return function (obj) {
        let arr = obj.split(",");
        let min;
        for (var i = 0; i < arr.length; i++) {
          for (var j = i; j < arr.length; j++) {
            if (arr[i] > arr[j]) {
              min = arr[j];
              arr[j] = arr[i];
              arr[i] = min;
            }
          }
        }
        let name = [];
        this.cities.forEach(item => {
          arr.forEach(ar => {
            if (ar == item.menuId) {
              name.push(item.menuName);
            }
          });
        });
        return name.join(",  ");
      };
    },
    postVerify(type) {
      return function (type) {
        switch (type) {
          case 0:
            return "学生"
            break;
          case 1:
            return "教师"
            break;
          case 2:
            return "管理员"
            break;
          case 3:
            return "超级管理员"
            break;
          default:
            break;
        }

      }
    }
  },
  methods: {
    _orgList() {
      orgList({}).then(res => {
        if (res.code == 0) {
          this.options = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    ddddd() {
      this.dialogVisible = false;
    },
    ccccc() {
      this.addVisible = false;
      this.checkedCities = [];
    },
    jumpLeft() {
      this.$router.push({
        path: "/home"
      });
    },
    deleteBtn() {
      moduleDelete({
        id: this.row.id,
        menuId: this.row.menuId,
        orgId: this.row.orgId
      })
        .then(res => {
          if (res.code == 200) {
            this.deleteDialogVisible = false;
            Message.success("删除成功");
            this._select();
          } else {
            this.deleteDialogVisible = false;
            Message.error("操作失败");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    seach() {
      moduleSelect({
        username: this.input_search.trim(),
        page: 1,
        limit: this.limit
      })
        .then(res => {
          if (res.code == 200) {
            this.list = res.data.userInfoList;
            this.total = res.data.total;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    cancel_update() {
      this.dialogVisible = false;
    },
    cancel() {
      this.checkedCities = [];
      this.addVisible = false;
    },
    btn(saa) {
      if (this.username == "") {
        Message.warning("请输入用户名");
      } else if (this.password == "") {
        Message.warning("请输入密码");
      } else if (this.phone == "") {
        Message.warning("请输入手机号码");
      } else if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(this.phone)) {
        Message.warning("请输入正确的手机号码");
      } else if (this.email == "") {
        Message.warning("请输入电子邮箱");
      } else if (
        !/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.email)
      ) {
        Message.warning("请输入正确的邮箱地址");
      } else if (this.type == null) {
        Message.warning("请选择用户类型");
      } else if (this.checkedCities.length == 0) {
        Message.warning("请选择菜单");
      } else if (this.type !== 3 && (this.orgId == null || this.orgId == '')) {
        Message.warning("请选择机构名称");
      } else {
        if (saa == 1) {
          this.btn_add();
        } else {
          this.btn_update();
        }
      }
    },
    btn_add() {
      add({
        username: this.username,
        password: this.password,
        email: this.email,
        phone: this.phone,
        type: this.type,
        orgId: this.type == 3 ? '' : this.orgId,
        menuId: this.selectStr
      })
        .then(res => {
          if (res.code == 200) {
            Message.success("添加成功");
            this.addVisible = false;
            this.username = "";
            this.password = "";
            this.email = "";
            this.phone = "";
            this.type = null;
            this.orgId = JSON.parse(localStorage.getItem("userInfos")).orgId;
            this.checkedCities = [];
            this._select();
          } else {
            Message.error(res.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    btn_update() {
      update({
        id: this.secletRow.id,
        userId: this.secletRow.userId,
        username: this.username,
        password: this.password,
        email: this.email,
        phone: this.phone,
        type: this.type,
        menuId: this.selectStr,
        orgId: this.type == 3 ? '' : this.orgId
      }).then(res => {
        if (res.code == 200) {
          let userInfos = JSON.parse(localStorage.getItem("userInfos"))
          if (userInfos.id == this.secletRow.id) {
            userInfos = {
              ...userInfos,
              username: this.username,
              email: this.email,
              phone: this.phone,
            }
            localStorage.setItem('userInfos', JSON.stringify(userInfos))
          }
          this.dialogVisible = false;
          this.username = "";
          this.password = "";
          this.email = "";
          this.phone = "";
          this.type = null;
          this.orgId = userInfos.orgId;
          this.checkedCities = [];
          this._select();
        }
      }).catch(err => {
        console.log(err);
      });
    },
    _select() {
      moduleSelect({
        page: this.page,
        limit: this.limit
      })
        .then(res => {
          console.log(res);
          if (res.code == 200) {
            this.list = res.data.userInfoList;
            this.total = res.data.total;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleDelete(idx, row) {
      this.deleteDialogVisible = true;
      this.row = row;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.page = val;
      this._select();
    },
    handleCheckedCitiesChange(value) {
      let arr = value.slice(0, value.length);
      this.selectStr = arr.toString();
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
    handleClick(idx, row) {
      console.log(row);
    },
    handleEdit(idx, row) {
      this.checkedCities = [];
      this.secletRow = row;
      this.selectStr = row.menuId;
      this.username = row.username;
      this.password = row.password;
      this.orgId = row.orgId;
      this.type = row.type;
      this.email = row.email;
      this.phone = row.phone;
      let arr = row.menuId == "" ? [] : row.menuId.split(",");
      if (arr.length > 0) {
        arr.forEach(item => {
          this.checkedCities.push(parseInt(item));
        });
      }

      this.dialogVisible = true;
    },
    add() {
      this.cities = [];
      this.username = "";
      this.password = "";
      this.email = "";
      this.phone = "";
      this.type = 0;
      this.orgId = JSON.parse(localStorage.getItem("userInfos")).orgId;
      this.checkedCities = [];
      list({
        username: JSON.parse(localStorage.getItem("userInfos")).username,
        orgId: this.orgId
      })
        .then(res => {
          if (res.code == 200) {
            res.data.forEach(element => {
              this.cities.push({
                menuName: element.menuName,
                menuId: element.menuId
              });
            });
            this.cities = JSON.parse(JSON.stringify(this.cities));
          }
        })
        .catch(err => {
          console.log(err);
        });
      this.addVisible = true;
    }
  },
  data() {
    return {
      page: 1,
      limit: 6,
      total: 0,
      currentPage1: 1,
      orgId: JSON.parse(localStorage.getItem("userInfos")).orgId,
      input_search: "",
      secletRow: {},
      dialogVisible: false,
      addVisible: false,
      input: "",
      username: "",
      password: "",
      email: "",
      phone: "",
      type: 0,
      list: [],
      checkAll: false,
      checkedCities: [],
      checkedCitiess: [],
      cities: [],
      citiesForloger: [],
      isIndeterminate: true,
      selectStr: "",
      deleteDialogVisible: false,
      row: {},
      sc: [],
      options: [],
      userInfo: JSON.parse(localStorage.getItem("userInfos")),
    };
  }
};



// WEBPACK FOOTER //
// ./src/components/List.vue